module.exports = __webpack_public_path__ + "static/media/p2008left.5107cd93.jpg";